import moment from 'moment';

import { BusinessDownloadConfig } from '../types';
import { ECHARTS_DATASOURCE_METRICS_PC } from '@/pages/intelligence/utils/constant';
import {
  DATASOURCE_METRICS_VALUE_PC,
  DATASOURCE_METRICS_BACKEND_CONSOLE,
} from '@/pages/intelligence/pages/TopCharts/PCGames/_config/constant';
import { TOPCHARTS_COMMON_DOWNLOAD_API, publisherCheckboxList, storeRankTopBasicInfoFormItem, storeRankTopRankingsFormItem } from './common';

const defaultDate = moment().format('YYYY-MM-DD');

const storeRankTopWebFormList = [
  {
    label: 'dbi_label_time_settings',
    type: 'dateRangeDay' as const,
    defaultValue: [defaultDate, defaultDate],
    field: 'dateRange',
    options: [],
  },
  storeRankTopRankingsFormItem,
  storeRankTopBasicInfoFormItem,
];

const pcConfig: BusinessDownloadConfig = {
  'pc-MetricsTable': {
    apiUrl: TOPCHARTS_COMMON_DOWNLOAD_API,
    translate: true,
    formList: [
      {
        className: 'dbi-top-companies-source-metric-selector',
        label: 'dbi_label_metrics',
        type: 'cascadeMetricSelector',
        field: 'metrics',
        defaultValue: DATASOURCE_METRICS_VALUE_PC,
        cascadeOptions: ECHARTS_DATASOURCE_METRICS_PC,
      },
      publisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            // message:
            //   'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country', value: 'market' },
              { label: 'dbi_label_separate_by_region', value: 'region' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
          {
            label: 'dbi_pcu_setting',
            type: 'metricSettings',
            defaultValue: '',
            field: 'metric_setting',
            options: [{ label: 'steamcharts', value: 'pcu' }],
          },
          {
            label: 'dbi_digital_revenue_setting',
            type: 'metricSettings',
            defaultValue: '',
            field: 'metric_setting',
            options: [{ label: 'mscience', value: 'digitalRevenue' }],
          },
          {
            label: 'dbi_physical_revenue_setting',
            type: 'metricSettings',
            defaultValue: '',
            field: 'metric_setting',
            options: [{ label: 'npd', value: 'revenue' }],
          },
          {
            label: 'dbi_premium_revenue_setting',
            type: 'metricSettings',
            defaultValue: '',
            field: 'metric_setting',
            options: [{ label: 'vginsights', value: 'est_revenue' }],
          },
          {
            label: 'dbi_price_setting',
            type: 'metricSettings',
            defaultValue: '',
            field: 'metric_setting',
            options: [{ label: 'vginsights', value: 'est_price' }],
          },
        ],
      },
    ],
    bubbleText:
      'dbi_info_download_tip',
  },
  'pc-PCU': {
    apiUrl: TOPCHARTS_COMMON_DOWNLOAD_API,
    translate: true,
    formList: [
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'metrics',
        defaultValue: [
          'source_steam__pcu',
          'source_steam__acu',
          'steamfollowers',
          'alinea__steamreviews',
        ],
        options: [
          { label: 'dbi_metric_source_steam_pcu', value: 'source_steam__pcu', source: 'source_steam' },
          { label: 'dbi_metric_source_steam_acu', value: 'source_steam__acu', source: 'source_steam' },
          { label: 'dbi_metric_vgi_steam_followers', value: 'steamfollowers', source: 'vginsights', dataSource: 'source_steam' },
          { label: 'dbi_metric_alinea_steam_pcu', value: 'alinea__pcu', source: 'alinea' },
          { label: 'dbi_metric_alinea_steam_acu', value: 'alinea__acu', source: 'alinea' },
          { label: 'dbi_metric_alinea_steam_followers', value: 'alinea__steamfollowers', source: 'alinea' },
          { label: 'dbi_metric_alinea_steam_reviews', value: 'alinea__steamreviews', source: 'alinea' },
          { label: 'dbi_metric_gamalytic_steam_pcu', value: 'gamalytic__pcu', source: 'gamalytic' },
          { label: 'dbi_metric_gamalytic_steam_acu', value: 'gamalytic__acu', source: 'gamalytic' },
          { label: 'dbi_metric_gamalytic_steam_followers', value: 'gamalytic__steamfollowers', source: 'gamalytic' },
          { label: 'dbi_metric_gamalytic_steam_reviews', value: 'gamalytic__steamreviews', source: 'gamalytic' },
          { label: 'dbi_metric_vgi_steam_pcu', value: 'pcu', source: 'vginsights' },
          { label: 'dbi_metric_vgi_steam_acu', value: 'acu', source: 'vginsights' },
          { label: 'dbi_metric_vgi_steam_reviews', value: 'steamreviews', source: 'vginsights' },
        ],
      },
      publisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            // message:
            //   'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [{ label: 'dbi_label_aggregated', value: 'aggregated' }],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
          {
            label: 'dbi_pcu_setting',
            type: 'metricSettings',
            defaultValue: '',
            field: 'metric_setting',
            options: [{ label: 'gamalytic', value: 'pcu' }],
          },
        ],
      },
    ],
    bubbleText:
      'dbi_info_download_tip',
  },
  'pc-DigitalRevenue': {
    apiUrl: TOPCHARTS_COMMON_DOWNLOAD_API,
    translate: true,
    formList: [
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'metrics',
        defaultValue: ['digitalRevenue', 'units', 'digitalARPPU', 'ast'],
        options: [
          {
            label: 'dbi_metric_digitalRevenue',
            value: 'digitalRevenue',
            disabled: false,
            message: '',
          },
          { label: 'dbi_metric_units', value: 'units', disabled: false, message: '' },
          {
            label: 'dbi_metric_digital_arpu_$',
            value: 'digitalARPPU',
            disabled: false,
            message: 'dbi_metric_digital_arpu_dollor_tips',
          },
          { label: 'dbi_metric_ast_$', value: 'ast', disabled: false, message: '' },
        ],
      },
      publisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_segment_settings',
            type: 'checkboxGroup',
            defaultValue: [
              'Full Game',
              'DLC: All Other',
              'DLC: Expansion',
              'DLC: Content Pre-Purchase Pass',
              'DLC: Unlockable Content Pass',
              'MTX',
              'Subscription',
            ],
            field: 'download_segments',
            options: [
              { label: 'Base Game', value: 'Full Game', disabled: false, message: '' },
              { label: 'DLC: All Other', value: 'DLC: All Other', disabled: false, message: '' },
              { label: 'DLC: Expansion', value: 'DLC: Expansion', disabled: false, message: '' },
              {
                label: 'DLC: Season Pass',
                value: 'DLC: Content Pre-Purchase Pass',
                disabled: false,
                message: '',
              },
              {
                label: 'DLC: Battle Pass',
                value: 'DLC: Unlockable Content Pass',
                disabled: false,
                message: '',
              },
              { label: 'MTX', value: 'MTX', disabled: false, message: '' },
              { label: 'Subscription', value: 'Subscription', disabled: false, message: '' },
            ],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            // message:
            //   'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country', value: 'market' },
              { label: 'dbi_label_separate_by_region', value: 'region' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
          {
            label: 'dbi_digital_revenue_setting',
            type: 'metricSettings',
            defaultValue: '',
            field: 'metric_setting',
            options: [{ label: 'mscience', value: 'digitalRevenue' }],
          },
        ],
      },
    ],
    bubbleText:
      'dbi_info_download_tip',
  },
  'pc-PhysicalRevenue': {
    apiUrl: TOPCHARTS_COMMON_DOWNLOAD_API,
    translate: true,
    formList: [
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'metrics',
        defaultValue: ['revenue', 'physical_units'],
        options: [
          { label: 'dbi_metric_physical_revenue', value: 'revenue' },
          { label: 'dbi_metric_physical_units', value: 'physical_units' },
        ],
      },
      publisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            // message:
            //   'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [{ label: 'dbi_label_aggregated', value: 'aggregated' }],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
          {
            label: 'dbi_physical_revenue_setting',
            type: 'metricSettings',
            defaultValue: '',
            field: 'metric_setting',
            options: [{ label: 'npd', value: 'revenue' }],
          },
        ],
      },
    ],
    bubbleText:
      'dbi_info_download_tip',
  },
  'pc-MAU': {
    apiUrl: TOPCHARTS_COMMON_DOWNLOAD_API,
    translate: true,
    formList: [
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'metrics',
        defaultValue: ['mau', 'acquisition'],
        options: [
          { label: 'dbi_mau', value: 'mau' },
          { label: 'dbi_metric_acquisition', value: 'acquisition' },
        ],
      },
      publisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            // message:
            //   'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [{ label: 'dbi_label_aggregated', value: 'aggregated' }],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
    bubbleText:
      'dbi_info_download_tip',
  },
  'pc-SteamSales': {
    apiUrl: TOPCHARTS_COMMON_DOWNLOAD_API,
    translate: true,
    formList: [
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'metrics',
        defaultValue: [
          'alinea__est_revenue',
          'alinea__est_units',
          'alinea__est_price',
          'alinea__weighted_price',
          'alinea__players_by_country',
          'alinea__playtime',
          'alinea__steamfollowers',
        ],
        options: [
          // Alinea 指标（排在最前，默认选中）
          {
            label: 'dbi_metric_alinea_steam_est_revenue',
            value: 'alinea__est_revenue',
            source: 'alinea',
            disabled: false,
            message: '',
          },
          {
            label: 'dbi_metric_alinea_est_units',
            value: 'alinea__est_units',
            source: 'alinea',
            disabled: false,
            message: '',
          },
          {
            label: 'dbi_metric_alinea_est_price',
            value: 'alinea__est_price',
            source: 'alinea',
            disabled: false,
            message: '',
          },
          {
            label: 'dbi_metric_alinea_weighted_price',
            value: 'alinea__weighted_price',
            source: 'alinea',
            disabled: false,
            message: '',
          },
          {
            label: 'dbi_metric_alinea_players_by_country',
            value: 'alinea__players_by_country',
            source: 'alinea',
            disabled: false,
            message: '',
          },
          {
            label: 'dbi_metric_alinea_playtime_steam',
            value: 'alinea__playtime',
            source: 'alinea',
            disabled: false,
            message: '',
          },
          {
            label: 'dbi_metric_alinea_steam_followers',
            value: 'alinea__steamfollowers',
            source: 'alinea',
            disabled: false,
            message: '',
          },
          // Gamalytic 指标
          {
            label: 'dbi_metric_gamalytic_steam_est_revenue',
            value: 'gamalytic__est_revenue',
            source: 'gamalytic',
            disabled: false,
            message: '',
          },
          {
            label: 'dbi_metric_gamalytic_est_units',
            value: 'gamalytic__est_units',
            source: 'gamalytic',
            disabled: false,
            message: '',
          },
          {
            label: 'dbi_metric_gamalytic_est_price',
            value: 'gamalytic__est_price',
            source: 'gamalytic',
            disabled: false,
            message: '',
          },
          {
            label: 'dbi_metric_gamalytic_weighted_price',
            value: 'gamalytic__weighted_price',
            source: 'gamalytic',
            disabled: false,
            message: '',
          },
          {
            label: 'dbi_metric_gamalytic_players_by_country',
            value: 'gamalytic__players_by_country',
            source: 'gamalytic',
            disabled: false,
            message: '',
          },
          {
            label: 'dbi_metric_gamalytic_playtime_steam',
            value: 'gamalytic__playtime',
            source: 'gamalytic',
            disabled: false,
            message: '',
          },
          {
            label: 'dbi_metric_gamalytic_steam_followers',
            value: 'gamalytic__steamfollowers',
            source: 'gamalytic',
            disabled: false,
            message: '',
          },
          // VGI 指标
          {
            label: 'dbi_metric_vgi_steam_est_revenue',
            value: 'est_revenue',
            source: 'vginsights',
            disabled: false,
            message: '',
          },
          {
            label: 'dbi_metric_vgi_units',
            value: 'est_units',
            source: 'vginsights',
            disabled: false,
            message: '',
          },
          {
            label: 'dbi_metric_vgi_steam_price',
            value: 'est_price',
            source: 'vginsights',
            disabled: false,
            message: '',
          },
          {
            label: 'dbi_metric_vgi_weighted_price',
            value: 'weighted_price',
            source: 'vginsights',
            disabled: false,
            message: '',
          },
          {
            label: 'dbi_metric_vgi_playtime',
            value: 'playtime',
            source: 'vginsights',
            disabled: false,
            message: '',
          },
          {
            label: 'dbi_metric_vgi_followers',
            value: 'followers',
            source: 'vginsights',
            disabled: false,
            message: '',
          },
          {
            label: 'dbi_metric_vgi_players_by_country',
            value: 'players_by_country',
            source: 'vginsights',
            disabled: false,
            message: '',
          },
        ],
      },
      publisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            // message:
            //   'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
          {
            label: 'dbi_premium_revenue_setting',
            type: 'metricSettings',
            defaultValue: '',
            field: 'metric_setting',
            options: [{ label: 'vginsights', value: 'est_revenue' }],
          },
          {
            label: 'dbi_price_setting',
            type: 'metricSettings',
            defaultValue: '',
            field: 'metric_setting',
            options: [{ label: 'vginsights', value: 'est_price' }],
          },
        ],
      },
    ],
    bubbleText:
      'dbi_info_download_tip',
  },
  'pc-LifeTimePlayers': {
    apiUrl: TOPCHARTS_COMMON_DOWNLOAD_API,
    translate: true,
    formList: [
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'metrics',
        defaultValue: ['lifetime_player'],
        options: [{ label: 'dbi_lifetime_players', value: 'lifetime_player' }],
      },
      publisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            // message:
            //   'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [{ label: 'dbi_label_aggregated', value: 'aggregated' }],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
    bubbleText: 'dbi_info_download_tip',
  },
  'pc-newRelease': {
    apiUrl: 'api/v1/intelligence_pc/pcConsoleNewReleaseExcel',
    bubbleText: '',
    translate: true,
    formList: [publisherCheckboxList],
    // bubbleText:
    //   'It shows aggregated value below. If you want to see data separate by country or time, please download the data and choose relative options.',
  },
  'pc-upcoming': {
    apiUrl: 'api/v1/intelligence_pc/pcConsoleUpcomingExcel',
    bubbleText: '',
    translate: true,
    formList: [publisherCheckboxList],
  },
  'pc-store-rank-more': {
    apiUrl: '/api/v1/intelligence_pc/topChartsPCStoreRankExcel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_label_chart',
        type: 'text',
        text: 'top',
      },
      {
        label: 'dbi_label_basic_info_optional',
        type: 'checkbox',
        field: 'data_sources',
        defaultValue: {
          release_date_show: false,
          genre_show: false,
        },
        options: [
          { label: 'dbi_release_date', value: 'release_date_show' },
          { label: 'dbi_label_genre', value: 'genre_show' },
        ],
      },
      {
        label: 'dbi_label_data_calculation_change',
        type: 'switch',
        defaultValue: true,
        field: 'ratio_show',
        options: [],
      },
    ],
  },
  'pc-steam-store-rank-top': {
    apiUrl: '/api/v1/intelligence_pc/topChartsMobileStoreRankExcel',
    bubbleText: '',
    translate: true,
    formList: storeRankTopWebFormList,
  },
  'pc-epic-store-rank-top': {
    apiUrl: '/api/v1/intelligence_pc/topChartsMobileStoreRankExcel',
    bubbleText: '',
    translate: true,
    formList: storeRankTopWebFormList,
  },
};

export default pcConfig;
